import { HttpErrorResponse, HttpHeaders, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { ToasterService } from '../services/toaster.service';

export const httpHandlerInterceptor: HttpInterceptorFn = (req, next) => {
    const toastService: ToasterService = inject(ToasterService);

    const reqWithHeaders = req.clone({
        headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
            'X-APP-RELAYSTATE': location.href,
            'Access-Control-Allow-Methods': 'GET,HEAD,OPTIONS,POST,PUT,DELETE'
        }),
        withCredentials: true
    });
    return next(reqWithHeaders).pipe(
        catchError((error: HttpErrorResponse) => {
            if (error.error instanceof ErrorEvent) {
                toastService.showError(`Error del cliente: ${error.error.message}`);
            } else {
                toastService.handleHttpError(error);
            }
            return throwError(() => error);
        })
    );
};
